import React from "react";
import { useContentContext } from "./Content";

import styles from "./Content.module.css";

/**
 * @visibleName Content
 *.Footer
 */
const ContentFooter = ({ children }) => {
    // eslint-disable-next-line no-unused-vars
    const _ = useContentContext();

    return <div className={styles.footer}>{children}</div>;
};

export default ContentFooter;
